<template>
    <!-- Navbar Start -->
    <nav class="navbar navbar-expand bg-light navbar-light sticky-top px-4 py-0">
                <a href="/" class="navbar-brand d-flex d-lg-none me-4">
                    <h2 class="mb-0" style="color:#00C853;"><i class="fa fa-hashtag me-2"></i>ZGH</h2>
                </a>
                <a href="#" class="sidebar-toggler flex-shrink-0" style="color:#00C853;">
                    <i class="fa fa-bars"></i>
                </a>
                <form class="d-md-flex ms-4" @submit.prevent="goToSearch">
                     <input
                        v-model="search"
                        class="form-control border-0"
                        type="search"
                        placeholder="Rechercher patient"
                     >
                </form>
                <div class="navbar-nav align-items-center ms-auto">
                    <div class="nav-item dropdown" hidden>
                        <a href="#" class="nav-link dropdown-toggle" style="color:#00C853;" data-bs-toggle="dropdown">
                            <i class="fa fa-envelope me-lg-2"></i>
                            <span class="d-none d-lg-inline-flex">Message</span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0">
                            <a href="#" class="dropdown-item">
                                <div class="d-flex align-items-center">
                                    <img class="rounded-circle" src="/assets/img/user.jpg" alt="" style="width: 40px; height: 40px;">
                                    <div class="ms-2">
                                        <h6 class="fw-normal mb-0">Jhon send you a message</h6>
                                        <small>15 minutes ago</small>
                                    </div>
                                </div>
                            </a>
                            <hr class="dropdown-divider">
                            <a href="#" class="dropdown-item">
                                <div class="d-flex align-items-center">
                                    <img class="rounded-circle" src="/assets/img/user.jpg" alt="" style="width: 40px; height: 40px;">
                                    <div class="ms-2">
                                        <h6 class="fw-normal mb-0">Jhon send you a message</h6>
                                        <small>15 minutes ago</small>
                                    </div>
                                </div>
                            </a>
                            <hr class="dropdown-divider">
                            <a href="#" class="dropdown-item">
                                <div class="d-flex align-items-center">
                                    <img class="rounded-circle" src="/assets/img/user.jpg" alt="" style="width: 40px; height: 40px;">
                                    <div class="ms-2">
                                        <h6 class="fw-normal mb-0">Jhon send you a message</h6>
                                        <small>15 minutes ago</small>
                                    </div>
                                </div>
                            </a>
                            <hr class="dropdown-divider">
                            <a href="#" class="dropdown-item text-center">See all message</a>
                        </div>
                    </div>
                    <div class="nav-item dropdown" hidden>
                        <a href="#" class="nav-link dropdown-toggle" style="color:#00C853;" data-bs-toggle="dropdown">
                            <i class="fa fa-bell me-lg-2"></i>
                            <span class="d-none d-lg-inline-flex">Notification</span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0">
                            <a href="#" class="dropdown-item">
                                <h6 class="fw-normal mb-0">Profile updated</h6>
                                <small>15 minutes ago</small>
                            </a>
                            <hr class="dropdown-divider">
                            <a href="#" class="dropdown-item">
                                <h6 class="fw-normal mb-0">New user added</h6>
                                <small>15 minutes ago</small>
                            </a>
                            <hr class="dropdown-divider">
                            <a href="#" class="dropdown-item">
                                <h6 class="fw-normal mb-0">Password changed</h6>
                                <small>15 minutes ago</small>
                            </a>
                            <hr class="dropdown-divider">
                            <a href="#" class="dropdown-item text-center">See all notifications</a>
                        </div>
                    </div>
                    <div class="nav-item dropdown">
                        <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" style="color: #00C853;">
                            <i class="rounded-circle fa fa-user fa-1x"></i>
                            <span class="d-none d-lg-inline-flex p-1">{{ profil }}</span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0">
                            <router-link to="/profile" class="dropdown-item" title="Profile" active-class="activedf">Profile</router-link>
                            <a href="#" class="dropdown-item" title="Paramètres">Paramètres</a>
                            <a href="#" title="Déconnecter" class="dropdown-item" @click="logout">Déconnecter</a>
                        </div>
                    </div>
                </div>
            </nav>
            <!-- Navbar End -->
            <!-- Action clicked -->
        <button type="button" class="btn btn-primary" hidden data-bs-toggle="modal" data-bs-target="#myModal" id="openModalNoAccess">Open modal</button>
        <!-- Start Modal -->
        <div id="myModal" class="modal fade" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-confirm modal-lg">
                <div class="modal-content">
                    <div class="modal-header flex-column">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="icon-box bg-danger">
                            <i class="fa fa-times fa-2x text-white"></i>
                        </div>					
                        <h4 class="modal-title w-100" id="myModalLabel"><i class="fa fa-exclamation-triangle text-danger"></i>&nbsp;Non Autorisé</h4>
                    </div>
                    <div class="modal-body">                        
                        <h5 class="mt-4">Contactez l'administrateur!</h5>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" id="closeModalNoAccess" data-bs-dismiss="modal">Fermer</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Modal -->

</template>

<script>
import axios from 'axios'
const base_url=process.env.VUE_APP_API_URL;
    export default {
        name:"NavBarView",
          
        data(){
            return {
                search:'',
                profil:(this.$store.getters.currentUser).prenom??'',
                accessToken : JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
            }
        },
        methods:{
            logout() {
                console.log('LogOut');
                
                this.$store.commit('removeUser');
                this.$router.push('/');
            axios.delete(`${base_url}/logout`,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    if(response?.status==200){
                        console.log('Logout button clicked');
                        // console.log(response.data.message);
                        // this.$store.commit('removeUser');
                        // this.$router.push('/');
                    }                
                })
                .catch((error)=>{
                    if(error){
                    // Gérer d'autres erreurs ici
                        console.log('Une erreur est survenue!');
                        console.log('Autre erreur:', error);
                    }
                });
            },
            goToSearch() {
                if (this.search.trim()) {
                    this.$router.push({ name: 'patient-all', query: { search: this.search } });
                }
                else {
                    this.$router.push({ name: 'patient-all' });
                    }
            }
        },
    created(){

    },
    }
</script>

<style scoped>
.modal-confirm {		
	color: #636363;
	width: 400px;
}
.modal-confirm .modal-content {
	padding: 20px;
	border-radius: 5px;
	border: none;
	text-align: center;
	font-size: 14px;
}
.modal-confirm .modal-header {
	border-bottom: none;   
	position: relative;
}
.modal-confirm h4 {
	text-align: center;
	font-size: 26px;
	margin: 30px 0 -10px;
}
.modal-confirm .close {
	position: absolute;
	top: -5px;
	right: -2px;
}
.modal-confirm .modal-body {
	color: #999;
}
.modal-confirm .modal-footer {
	border: none;
	text-align: center;		
	border-radius: 5px;
	font-size: 13px;
	padding: 10px 15px 25px;
}
.modal-confirm .modal-footer a {
	color: #999;
}		
.modal-confirm .icon-box {
	width: 80px;
	height: 80px;
	margin: 0 auto;
	border-radius: 50%;
	z-index: 9;
	text-align: center;
	border: 3px solid #f15e5e;
}
.modal-confirm .icon-box i {
	color: #f15e5e;
	font-size: 46px;
	display: inline-block;
	margin-top: 13px;
}
.modal-confirm .btn, .modal-confirm .btn:active {
	color: #fff;
	border-radius: 4px;
	background: #60c7c1;
	text-decoration: none;
	transition: all 0.4s;
	line-height: normal;
	min-width: 120px;
	border: none;
	min-height: 40px;
	border-radius: 3px;
	margin: 0 5px;
}
.modal-confirm .btn-secondary {
	background: #c1c1c1;
}
.modal-confirm .btn-secondary:hover, .modal-confirm .btn-secondary:focus {
	background: #a8a8a8;
}
.modal-confirm .btn-danger {
	background: #f15e5e;
}
.modal-confirm .btn-danger:hover, .modal-confirm .btn-danger:focus {
	background: #ee3535;
}
.activedf {
  color: #FFF;
  background: #00C853;
}
</style>